module.exports = __webpack_public_path__ + "img/invite-mail.7fc11e75.png";